import { useMutation } from '@tanstack/react-query';
import { DeleteUser } from '../../../../Api/user';

export const useMutateDeleteUser = () =>
  useMutation({
    mutationFn: (data) => DeleteUser(data),
  });
